var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearchWhite = function SvgSearchWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "search-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.017,
    height: 22
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.708 20.145-4.087-4.048a9.9 9.9 0 1 0-1.524 1.524l4.049 4.049a1.093 1.093 0 1 0 1.562-1.529ZM9.921 17.621a7.7 7.7 0 1 1 7.7-7.7 7.7 7.7 0 0 1-7.7 7.7Z"
  })));
};
export default SvgSearchWhite;